
import React from 'react';
import HelpIcon from '../Fields/HelpIcon';
import HelpText from '../Fields/HelpText';
import FieldValidation from '../Fragments/FieldValidation';
import FieldError from '../Fragments/FieldError';
import Modal from '../Fragments/Modal';
// import CheckboxInput from '../Fields/CheckboxInput';
import Popup from '../Modals/FloodPopup';
// import { event } from 'react-ga';

let Quote = require('../Managers/Quote');
let FaSpinner = require('react-icons/lib/fa/spinner');
let HttpService = require('../Managers/HttpService');

const Config = HttpService.getConfigForHost();

const PAFLookup = React.createClass({
    propTypes: {
        fieldNamePrefix: React.PropTypes.string.isRequired,
        pafLookup: React.PropTypes.bool.isRequired,
        helpText: React.PropTypes.string,
        question: React.PropTypes.string.isRequired,
        mediumRiskQuestion: React.PropTypes.func.isRequired,
    },
    
    getInitialState() {
        return {
            isHelpVisible: false,
            isValid: this.isValid(),
            hasError: false,
            pafLookupPostcode: false,
            pafResults: false,
            isLoading: false,
            activeValue: this.getInitialStateForAddress(),
            errors: null,
            showPostcodeRiskModal: false,
            postcodeRiskResponse: null,
            hasAddressViolation: false,
            flood_risk_medium:false,
            isOpen: false,
            
            
        };
    },

    resetState() {
        window.localStorage.removeItem('flood_subsidence_risk');
        this.setState(this.getInitialState());
    },

    doValidation() {
       

        this.setState({
                isOpen: false
        });
        if (Quote.getCurrentAnswer('ins_address_line1') !== null && Quote.getCurrentAnswer('ins_address_postcode') !== null) {
            this.setState({
                hasError : false,
                errors : []
            });
            return true;
        }
        this.setState({
            hasError : true,
            errors : ["Please complete this question"]
        });
        return false;
    },
   
    getInitialStateForAddress() {
        this.setState({
            isOpen: false
    });
        
        if (Quote.getCurrentAnswer('ins_address_line1') !== null && Quote.getCurrentAnswer('ins_address_postcode') !== null) {
            let addressChunks = [];

            if (null != Quote.getCurrentAnswer('ins_address_line1')) {
                addressChunks.push(Quote.getCurrentAnswer('ins_address_line1'));
            }
            if (null != Quote.getCurrentAnswer('ins_address_line2')) {
                addressChunks.push(Quote.getCurrentAnswer('ins_address_line2'));
            }
            if (null != Quote.getCurrentAnswer('ins_address_line3')) {
                addressChunks.push(Quote.getCurrentAnswer('ins_address_line3'));
            }
            if (null != Quote.getCurrentAnswer('ins_address_postcode')) {
                addressChunks.push(Quote.getCurrentAnswer('ins_address_postcode'));
            }

            return addressChunks.join(', ');
        } else {
            return false;
        }
    },
    toggleHelpText: function() {
        this.setState({
            isHelpVisible: (this.state.isHelpVisible) ? false : true,
        });
    },
    isValid() {
        return Quote.hasAnswers(
            this.props.fieldNamePrefix+'_address_line1',
            this.props.fieldNamePrefix+'_address_postcode'
        );
    },

    setPafLookupPostcode: function(event) {
        const elements = document.getElementsByClassName('address-selection');
    
        // Loop through all elements with the class name 'hideMe'
        for (let i = 0; i < elements.length; i++) {
            // Hide each element by setting its display property to 'none'
            elements[i].style.display = 'block';
        }

        let pc = event.target.value.replace(/\s+/g, '').toUpperCase();

        if (pc.length > 4) {
            this.setState({
                pafLookupPostcode: pc
            });
        }
    },

    pafLookup: function() {
        // alert('test');
        // let ch= document.getElementById("chk_flood").checked;
        // console.log(ch);
       
    
        // setTimeout(function () {
        //     let ch= document.getElementById("chk_flood").checked;
        //     console.log(ch);

        //     if(ch==true){

        //         this.setState({isChecked: false});
                 

        //     }
        // }, 300);
        // localStorage.setItem("resultavailable",'false');
         
     

       

        window.localStorage.removeItem('flood_subsidence_risk');
        let postcode = document.getElementById('inputPostcode').value.replace(/\s+/g, '').toUpperCase();
//         alert(postcode);
       

//    setTimeout(function () {
//     let res= localStorage.getItem("resultavailable");
//         }, 300);
//         alert(res);
//         if(res=='true'){
//             postcode='LN67EL';
            
//         }
        let _this = this;
        let errorMessage = 'An address could not be found for the above postcode, if the property is a new build please call us for a quotation';
        this.setState({
            isOpen : false,
            isLoading: true,
            flood_risk_medium:false,
        });

        this.getQuoteRequest = $.ajax({
            type: Config.api.riskLookup.method,
            data: { "postcode": postcode},
            url: Config.api.riskLookup.url,

            success: function(results) {
               
                localStorage.setItem("resultavailable",'true');
                // We can only ascertain risk if there's results for that postcode
                if (typeof results !== 'undefined') {
                    // High Flood and Subsidence
                    if (results.flood_risk === 'HIGH' && results.subsidence_risk === true) {
                        _this.setState({
                            postcodeRiskResponse: results,
                            showPostcodeRiskModal: true,
                            postcodeRiskModal: {
                                title: 'Flood and Subsidence Exclusion',
                                exclusions: 'flood and subsidence',
                                button: {
                                    classes: 'btn btn-success text--transform-uppercase',
                                    text: 'I Understand'
                                }
                            }
                        });
                        _this.props.mediumRiskQuestion(false);

                    }
                    else if (results.flood_risk === 'MEDIUM' && results.subsidence_risk === true) {

                       window.localStorage.setItem('flood_subsidence_risk', true);
                        _this.setState({
                            
                            isOpen : true
                           
                        });
                    }
                    // Subsidence Only
                    else if (results.subsidence_risk === true) {
                        _this.setState({
                            postcodeRiskResponse: results,
                            showPostcodeRiskModal:  true,
                            postcodeRiskModal: {
                                title: 'Subsidence Exclusion',
                                exclusions: 'subsidence',
                                button: {
                                    classes: 'btn btn-success text--transform-uppercase',
                                    text: 'I Understand'
                                }
                            }
                        });
                        _this.props.mediumRiskQuestion(false);

                        // High Flood Only
                    } else if (results.flood_risk === 'HIGH') {
                        _this.setState({
                            postcodeRiskResponse: results,
                            showPostcodeRiskModal:  true,
                            postcodeRiskModal: {
                                title: 'Flood Exclusion',
                                exclusions: 'flood',
                                button: {
                                    classes: 'btn btn-success text--transform-uppercase',
                                    text: 'I Understand'
                                }
                            }
                        });
                        _this.props.mediumRiskQuestion(false);

                        // Medium Flood Risk
                    }  else if (results.flood_risk === 'MEDIUM') {
                        
                        //localStorage.setItem("flood_risk", results.flood_risk );
                        
                        _this.setState({
                            isOpen : true,
                            postcodeRiskResponse: results,
                            showPostcodeRiskModal: false,
                            flood_risk_medium:true,
                        });
                      
                        _this.props.mediumRiskQuestion(true);

                        // Low Flood Risk
                    } else if (results.flood_risk === 'LOW') {
                        _this.setState({
                            postcodeRiskResponse: results,
                            showPostcodeRiskModal: false,
                        });
                        _this.props.mediumRiskQuestion(false);
                    }

                    this.getQuoteRequest = $.ajax({
                        type: Config.api.addressLookup.method,
                        url: Config.api.addressLookup.url + postcode,
                        dataType: 'json',
                        success: function(result) {
                            if ('ins' === _this.props.fieldNamePrefix && postcode.match(/^((IM|GY|JE)[AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {0,3})/i)) {
                                _this.setState({ hasAddressViolation: true });
                                $('.form-navigation .btn-success').hide();
                            } else {
                                _this.setState({ hasAddressViolation: false });
                                $('.form-navigation .btn-success').show();
                            }
                            _this.setState({
                                isLoading: false,
                                pafResults: result,
                                isValid: false,
                                hasError: false
                            });
                        },
                        error: function() {
                            _this.setState({
                                isLoading: false,
                                pafResults: false,
                                isValid: false,
                                hasError: true,
                                errors: [errorMessage]
                            });
                        }
                    });
                }
            },
            error: function(xhr) {
                if (xhr.status != 404) {
                    _this.setState({
                        isLoading: false,
                        pafResults: false,
                        isValid: false,
                        hasError: true,
                        errors: [errorMessage]
                    });
                }
            }
        });
    },

    closePostcodeRiskModal: function() {
        this.setState({
            showPostcodeRiskModal: false,
            postcodeRiskModal: false
        });
    },

    handleSelection: function(event) {
        // the entire formatted string
        let a = JSON.parse(event.target.value);
        if (a.Formatted == undefined) {
            return false;
        }

        let formatted = a.Formatted;

        if (a.town == a.county) {
            formatted = a.Formatted;
            let countyIndex = formatted.lastIndexOf(a.county + ',');
            formatted = formatted.substring(countyIndex, 0).trim();
        }

        let townIndex = formatted.lastIndexOf(a.town + ',');
        let al1 = formatted.substring(townIndex, 0).trim();
        let firstline = al1.replace(/,\s*$/, "");
        let al2;

        let lastComma = firstline.lastIndexOf(",");
        if (lastComma > -1) {
            al2 = firstline.substring(lastComma + 1).trim();
            firstline = firstline.replace(al2, '');
            firstline = firstline.replace(/,\s*$/, "");
        } else {
            let firstSpace = firstline.indexOf(" ");
            al2 = firstline.substring(firstSpace + 1).trim();
            firstline = firstline.replace(al2, '');
            firstline = firstline.replace(/,\s*$/, "");
        }

        this.setAddress(firstline.trim(), al2.trim(), a.town.trim(), a.postcode);
    },

    setAddress: function(address1, address2, address3, postcode) {
        Quote.set(this.props.fieldNamePrefix + '_address_line1', address1);
        if (undefined != address2 || null != address2) {
            Quote.set(this.props.fieldNamePrefix + '_address_line2', address2);
        }
        if (undefined != address3 || null != address3) {
            Quote.set(this.props.fieldNamePrefix + '_address_line3', address3);
        }
        Quote.set(this.props.fieldNamePrefix + '_address_postcode', postcode);
        this.setState({
            activeValue: this.getInitialStateForAddress(),
            isValid: true,
        }, () => {
            this.doValidation();
        });
    },

    clearPafResults: function() {
        this.setState({
            isOpen: false,
            pafResults: false,
            pafLookupPostcode: false,
            activeValue: false
        });
        Quote.set(this.props.fieldNamePrefix + '_address_line1', '');
        Quote.set(this.props.fieldNamePrefix + '_address_line2', '');
        Quote.set(this.props.fieldNamePrefix + '_address_line3', '');
        Quote.set(this.props.fieldNamePrefix + '_address_postcode', '');
    },
   
    render() {
        let dv = "0";
        let pafoptions = [];

        if (this.state.pafResults) {
            pafoptions.push(<option key={0} value="0">Please select...</option>);
            this.state.pafResults.forEach(function(i, index){
                pafoptions.push(<option key={index + 1} value={JSON.stringify(i)}>{i.Formatted.replace(/[,]/g, ', ')}</option>);
            }, this);

        } else if (this.state.activeValue) {
             pafoptions.push(<option key={0}>{this.state.activeValue}</option>);
        }

        return (
            <div>
                <question-row>
                    <div className="question-main">
                        <div className="question-top">
                            <label>{this.props.question}</label>
                            {this.props.helpText ? <HelpIcon onClick={this.toggleHelpText} />: null}
                        </div>

                        <div className="question-input" >
                            {!this.state.activeValue ?
                            <div className="input-group paf" id="question-input">
                                <input type="text" id="inputPostcode" ref="inputPostcode" name="pafsource" onBlur={this.setPafLookupPostcode} />
                                <button className="btn btn-default" onClick={this.pafLookup}>Find my address {this.state.isLoading ? <FaSpinner className="spin" /> : ''}
                                </button>
                                    {this.state.isOpen  == true ?  
                                    <Popup trigger={true}> 
                                    </Popup>: null
                                    }
                              
                            </div>
                            : null}
                      
                            {(this.state.pafResults || this.state.activeValue) ?
                               <div id="address-selection">   
                                      
                                       

                                    <div className="clearfix address-selection" >
                                        <label>Please select your address from the list</label>
                                        <select defaultValue={dv} onChange={this.handleSelection}>{pafoptions}</select>
                                        {this.state.activeValue ? <p>Not correct? 
                                            <span className="underline pointer" onClick={this.clearPafResults}>Change your address</span></p> : null}
                                    </div>
                                </div>
                            : null
                            }
                           
                            {this.props.helpText ? <HelpText text={this.props.helpText} active={this.state.isHelpVisible} /> : null}
                            {this.state.hasError ? <FieldError errors={this.state.errors} /> : null}
                        </div>
                    </div>
                    <div className="question-extra">
                            <FieldValidation isValid={this.state.isValid} hasError={this.state.hasError} />
                        </div>

                        {this.state.showPostcodeRiskModal ?
                            <Modal
                                closeFunction={this.closePostcodeRiskModal}
                                title={this.state.postcodeRiskModal.title}
                                bodyTemplate="postcode-risk"
                                templateProps={this.state.postcodeRiskModal}
                                isActive={this.state.showPostcodeRiskModal}
                                closeButton={this.state.postcodeRiskModal.button}
                                isAlertModal={true}
                                hasFooter={true}
                            />
                        : null }
                    
                </question-row>

                {this.state.hasAddressViolation ?
                    <question-row>
                        <div className="question-main">
                            <p>Unfortunately we're unable to offer you a policy, as cover isn't available in the Channel Islands or the Isle of Man. If the property you're looking to insure isn't in the Channel Islands or the Isle of Man then please double check the post code you have entered. If you're still experiencing problems, or if you have any further queries or questions, please call us.</p>
                        </div>
                    </question-row>
                : null}
            </div>
        );
    }
});

export default PAFLookup;



/** WEBPACK FOOTER **
 ** ./src/components/Fragments/PAFLookup.js
 **/